import { ITransactionResponse } from 'types/exchange';
import {
  SELL_ITEMS_FAILURE,
  SELL_ITEMS_REQUESTED,
  SELL_ITEMS_SUCCESS,
} from 'actiontypes/exchange';

import makeTransaction from './makeTransaction';

/** ----------------------------------------------------------------------------
 * SELL ITEMS
 -----------------------------------------------------------------------------*/

export const sellItemsRequested = () => ({ type: SELL_ITEMS_REQUESTED });

export const sellItemsSuccess = (data: ITransactionResponse) => ({ type: SELL_ITEMS_SUCCESS, payload: data });

export const sellItemsFailure = (error: any) => ({
  type: SELL_ITEMS_FAILURE,
  error: true,
  status: error.response && error.response.status,
  stuff: error,
});

const sellItems = makeTransaction('sell', {
  failure: sellItemsFailure,
  requested: sellItemsRequested,
  success: sellItemsSuccess,
});
export default sellItems;